const CorrespondenceTab = () => {
  return <div>CorrespondenceTab</div>;
};

export default CorrespondenceTab;
